import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const getStateApi = createAsyncThunk('state', async () => {
    const response = await axiosInstance.get('/states');
    return response.data;
});

const stateSlice = createSlice({
    name: "state",
    initialState: {
        data: [],
        errors: [],
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStateApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(getStateApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getStateApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.loading = false;
            });
    }
});

export default stateSlice.reducer;
